import * as Diagram from "../../../../components/diagram";

export const CaseCount = {
  label: "個案篩檢數",
  key: "CaseCount",
  path: "ElderlyHealthCheckup/CaseCount",
  api: "TCS_V_OldStudyList02V",
  render: (options) => <Diagram.ElderlyHealthCheckup.CaseCount {...options} />,
  isRaw: true,
  isPage: true,
  columns: [
    {
      key: "PID",
      field: "PID",
      header: "PID",
    },
    {
      key: "Name",
      field: "Name",
      header: "名字",
    },
    {
      key: "Region",
      field: "Region",
      header: "鄉鎮",
    },
    {
      key: "NumOfStudy",
      field: "NumOfStudy",
      header: "篩檢次數",
    },
  ],
};
